<template>
  <div class="mt-4">
    <div class="d-flex justify-content-between align-items-center mb-4">
      <h3>Update PAX Passports</h3>
      <div>
        <d-button
          theme="secondary"
          class="mr-2"
          @click="$emit('cancel')">
          Cancel
        </d-button>
      </div>
    </div>

    <pax-update-item
      v-for="(pax, paxIndex) in paxData"
      :key="'update-item-' + pax.id"
      :countriesOptions="countriesOptions"
      :itemIndex="paxIndex"
      :operators="operators"
      :scanned-item="pax"/>
  </div>
</template>

<script>
import PaxUpdateItem from '@/components/form-parts/PaxUpdateItem.vue';

export default {
  name: 'pax-update',
  components: {
    'pax-update-item': PaxUpdateItem
  },
  props: {
    countriesOptions: {
      default: () => [],
      type: Array
    },
    operators: {
      default: () => [],
      type: Array
    },
    paxData: {
      required: true,
      type: Array
    }
  }
}
</script>
